/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档



export type API75074Req = {};



export interface API75074Res {
  /** Token对象  */
  token?: string;
  /** Token的有效期时间戳（单位：秒。例如1553825814换算为北京时间为：201932910:16:54，即Token在该时间之前有效。）。  */
  expireTime?: number;
  
};


// 接口函数 75074 创建阿里云token

export interface IUseGetAPI75074Return {
  /** 创建阿里云token: 接口请求状态 */
  isAPI75074Loading: boolean;
  /** 创建阿里云token: 接口请求返回数据 */
  dataAPI75074: API75074Res;
  /**  创建阿里云token: 接口数据请求方法 */
  fetchAPI75074Data: ( config?: YWRequestConfig) => Promise<API75074Res>;
  /** 创建阿里云token: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI75074 = ():IUseGetAPI75074Return => {
  let isMount = true;
  const [isAPI75074Loading, setIsAPI75074Loading] = useState(false);
  const [dataAPI75074, setDataAPI75074] = useState<API75074Res>({} as API75074Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/voice/ali/token/auth`;

  const fetchAPI75074Data = async ( config?: YWRequestConfig): Promise<API75074Res> => {
  
    if ( isMount ) {
      setIsAPI75074Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API75074Res>(`${basePath}/yoaichat-web/chat/voice/ali/token/auth`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI75074(res || {} as API75074Res);
        setIsAPI75074Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75074Loading(false);
      }
      return false as unknown as API75074Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75074Loading,
    dataAPI75074,
    fetchAPI75074Data,
    requestUrl,
  }
}

